import React from 'react';
import * as DataList from 'components/DataList';

// What a job's empty tab says: what belongs there. Adding one is the tab bar's
// button (pages/jobs/show.js), so there's no second button here. The icon tile
// takes the colour of that kind of record (as the New menu and the form
// panels). Built on the shared DataList.Notice. Styles: .jp-empty in
// styles/job-page.scss.
const KINDS = {
  'work-orders': {
    icon: 'clipboard',
    title: 'No work orders yet',
    message: 'A work order is where technicians record the work done and the parts used on this job.',
  },
  estimates: {
    icon: 'document',
    title: 'No estimates yet',
    message: 'Price the work before it starts. Estimates made for this job show up here.',
  },
  invoices: {
    icon: 'dollar',
    title: 'No invoices yet',
    message: 'Bill the client for this job. Invoices made for it, or from its work orders, show up here.',
  },
  'time-logs': {
    icon: 'time',
    title: 'No time logged yet',
    message: 'Hours technicians log on this job’s work orders show up here.',
  },
  files: {
    icon: 'paperclip',
    title: 'No files yet',
    message: 'Photos and documents for this job show up here. Use Upload files to add some.',
  },
  activity: {
    icon: 'history',
    title: 'No activity yet',
    message: 'Changes to this job, its work orders, estimates and invoices show up here as they happen.',
  },
};

const JobEmpty = ({ kind }) => {
  const k = KINDS[kind];
  return (
    <div className={`jp-empty jp-empty--${kind}`}>
      <DataList.Notice icon={k.icon} title={k.title} message={k.message} />
    </div>
  );
};

export default JobEmpty;
